import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitText from 'gsap/SplitText'
import CustomEase from 'gsap/CustomEase'

import { desktop } from './check-res'

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase)

const textAnimate = document.querySelectorAll('.text-animate')
const textRowsAnimate = document.querySelectorAll('.text-rows-animate')

window.addEventListener('load', () => {
	textAnimate.forEach((text) => {
		let textSplit = new SplitText(text, {
			type: 'words, chars',
			wordsClass: 'word',
			charsClass: 'char',
		})
		let textChars = textSplit.chars

		gsap
			.timeline({
				scrollTrigger: {
					trigger: text,
					start: 'top 65%',
				},
			})
			.to(
				textChars,
				{
					duration: 1,
					translateY: 0,
					ease: 'power4.out',
					stagger: 0.1,
				},
				0
			)
			.to(
				text,
				{
					duration: 2,
					translateX: 0,
					ease: CustomEase.create('custom', 'M0,0 C0.796,0 0.215,1 1,1 '),
					onComplete: () => {
						if (text.querySelector('sup .word')) {
							text.querySelector('sup .word').style.opacity = 1
						}
					},
				},
				'<-=0.5'
			)
	})

	textRowsAnimate.forEach((text) => {
		let textSplit = new SplitText(text, {
			type: 'lines, words',
			linesClass: 'line',
			wordsClass: 'word',
		})
		let textWords = textSplit.words

		gsap.to(textWords, {
			duration: 1,
			translateY: 0,
			ease: 'power4.out',
			stagger: 0.05,
			scrollTrigger: {
				trigger: text,
				start: 'top 75%',
			},
			onComplete: () => {
				if (text.querySelector('sup .word')) {
					text.querySelector('sup .word').style.opacity = 1
				}
			},
		})
	})

	if (desktop) {
		let merchLinkSplit = new SplitText('.merch__link', {
			type: 'chars',
			charsClass: 'char',
		})
		let merchLinkChars = merchLinkSplit.chars

		let contactHead = new SplitText('.contact-anime-head', {
			type: 'lines, words',
			linesClass: 'line',
			wordsClass: 'word',
		})
		let contactHeadWords = contactHead.words

		gsap.to(merchLinkChars, {
			duration: 1.5,
			translateY: 0,
			ease: 'power4.out',
			stagger: 0.1,
			scrollTrigger: {
				trigger: '.merch__link',
				start: 'top 65%',
			},
		})

		gsap
			.timeline({
				defaults: {
					ease: 'power4.out',
					duration: 2,
				},
				scrollTrigger: {
					trigger: '.contact__title',
					start: '20% bottom',
				},
			})
			.to(
				'.contact__title-img',
				{
					translateY: 0,
				},
				0
			)
			.to(
				contactHeadWords,
				{
					duration: 1,
					translateY: 0,
					stagger: 0.05,
				},
				'<+=0.5'
			)
			.to(
				'.contact-anime-opacity',
				{
					duration: 1,
					opacity: 1,
				},
				'<+=1'
			)
	}
})
